import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-card-persone',
  templateUrl: './sample-card-persone.component.html',
  styleUrls: ['./sample-card-persone.component.scss']
})
export class SampleCardPersoneComponent implements OnInit {

  @Input() block: any;
  public domainWebsite = environment.urlApi;

  constructor(
    private helpersService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {}

  public toPage(field_titolo: string): string {
    return this.helpersService.retriveLinkTagA(field_titolo, 'a').link;
  }

  public setImage(item: string): any {
    let personImage = {
      url: this.domainWebsite + this.helpersService.retrieveImage(item, 'src'),
      tagAlt: this.helpersService.retrieveImage(item, 'alt')
    };
    return personImage;
  }

}
